import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { SEOHead } from '../components/SEOHead';
export function PrivacyPolicyPage() {
  const lastUpdated = 'April 2, 2026';
  return <div className="bg-viridia-black min-h-screen pt-32 pb-24" data-id="element-2559" data-mp="2muk8smsmorg3">
      <SEOHead title="Privacy Policy | Viridia Analytics" description="Privacy Policy for Viridia Analytics. Learn how we collect, use, and protect your personal data." canonical="/privacy" data-id="element-2560" data-mp="2mw57molz6wjr" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2561" data-mp="2is7503xfz3ly">
        <ScrollReveal data-id="element-2562" data-mp="2its0bvrkyqkv">
          <div className="text-center mb-16" data-id="element-2563" data-mp="243kr86ngqjwu">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-2564" data-mp="244vtu3569lmd">
              Privacy Policy
            </h1>
            <p className="text-gray-400" data-id="element-2565" data-mp="292xf8uq2lx10">Last Updated: {lastUpdated}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-2566" data-mp="1v4z92clwl6wl">
          <div className="bg-viridia-surface border border-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none" data-id="element-2567" data-mp="1z4zo9zgttm4p">
            <div className="space-y-8 text-gray-300 leading-relaxed" data-id="element-2568" data-mp="29qbopeqbiab0">
              <section data-id="element-2569" data-mp="24t1t1hcc52eq">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2570" data-mp="24rqo3e75lom1">
                  1. Introduction
                </h2>
                <p data-id="element-2571" data-mp="2jp17ratya0su">
                  Viridia Analytics ("we," "our," or "us") respects your privacy
                  and is committed to protecting your personal data. This
                  Privacy Policy explains how we collect, use, disclose, and
                  safeguard your information when you visit our website or use
                  our marketing and automation services.
                </p>
              </section>

              <section data-id="element-2572" data-mp="1w08anb1ldmwn">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2573" data-mp="1vzygrcdfevlo">
                  2. Information We Collect
                </h2>
                <p className="mb-2" data-id="element-2574" data-mp="1892usvvniumc">
                  We may collect the following types of information:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2575" data-mp="139q768wyhjip">
                  <li data-id="element-2576" data-mp="1syx1nlz8e6jh">
                    <strong data-id="element-2577" data-mp="1szg9g9v63ejs">Personal Identification Information:</strong> Name,
                    email address, phone number (including for SMS
                    communications), and company details when you fill out a
                    contact form, book a consultation, or opt in to messaging.
                  </li>
                  <li data-id="element-2578" data-mp="1a0u6epg3bdd8">
                    <strong data-id="element-2579" data-mp="1a1cdkh4ajbzx">Business Information:</strong> Information about
                    your business, marketing goals, current advertising
                    platforms, and CRM systems.
                  </li>
                  <li data-id="element-2580" data-mp="1j0haxk448zai">
                    <strong data-id="element-2581" data-mp="1j07f3fwe3xww">Usage Data:</strong> Information about how you
                    interact with our website, including IP addresses, browser
                    types, pages visited, and time spent on pages.
                  </li>
                </ul>
              </section>

              <section data-id="element-2582" data-mp="2ze7dgmfl7fi1">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2583" data-mp="2zhv7rnsuw5xt">
                  3. How We Use Your Information
                </h2>
                <p className="mb-2" data-id="element-2584" data-mp="issmx5ge4kan">
                  We use the collected information for various purposes,
                  including:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2585" data-mp="e0ixdqj6tm8w">
                  <li data-id="element-2586" data-mp="92hiziwpib3r">To provide, operate, and maintain our services.</li>
                  <li data-id="element-2587" data-mp="52grawklk3er">
                    To communicate with you, including responding to inquiries
                    and providing customer support.
                  </li>
                  <li data-id="element-2588" data-mp="572nj517vrz">
                    To send administrative information, such as updates to our
                    terms or policies.
                  </li>
                  <li data-id="element-2589" data-mp="3mblv12qeggxf">
                    To analyze usage patterns and improve our website and
                    service offerings.
                  </li>
                  <li data-id="element-2590" data-mp="1ki65k961t841">
                    To manage and optimize advertising campaigns on your behalf.
                  </li>
                </ul>
              </section>

              <section data-id="element-2591" data-mp="1shj6whofvgbo">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2592" data-mp="1xj0525fjgook">
                  4. SMS/Text Messaging Privacy
                </h2>
                <p className="mb-2" data-id="element-2593" data-mp="1ikejkeiuxeta">
                  If you opt in to receive text messages from us, the following
                  applies:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2594" data-mp="19schkbt53qgw">
                  <li data-id="element-2595" data-mp="19qt3mruyhria">
                    We collect phone numbers when users submit contact forms,
                    book consultations, or opt in to receive text messages.
                  </li>
                  <li data-id="element-2596" data-mp="zslpegs1xnjz">
                    Phone numbers may be used to send appointment confirmations,
                    follow-up messages, service updates, and promotional offers
                    via SMS.
                  </li>
                  <li data-id="element-2597" data-mp="uw50vlgxx76d">
                    By providing your phone number and opting in, you consent to
                    receive automated text messages from Viridia Analytics.
                  </li>
                  <li data-id="element-2598" data-mp="78rlejdqijkg">
                    Message and data rates may apply. Message frequency varies.
                  </li>
                  <li data-id="element-2599" data-mp="l8spe7paq745">
                    You can opt out at any time by replying{' '}
                    <strong data-id="element-2600" data-mp="g7v77v4add2n">STOP</strong> to any message.
                  </li>
                  <li data-id="element-2601" data-mp="v5nkegmd1pdo">
                    Reply <strong data-id="element-2602" data-mp="v4vzq0uaxc26">HELP</strong> for assistance.
                  </li>
                  <li data-id="element-2603" data-mp="q7vt9otji7aj">
                    <strong data-id="element-2604" data-mp="q6awdsjr6c9i">
                      SMS consent and phone numbers are NOT shared with third
                      parties or affiliates for marketing purposes.
                    </strong>
                  </li>
                  <li data-id="element-2605" data-mp="zz072l7hbm3s">
                    We use third-party platforms (e.g.,
                    GoHighLevel/LeadConnector) solely to facilitate our own SMS
                    communications with you.
                  </li>
                </ul>
              </section>

              <section data-id="element-2606" data-mp="6lh41ydfr2p9">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2607" data-mp="6i2yyide0fe4">
                  5. Cookies and Tracking Technologies
                </h2>
                <p data-id="element-2608" data-mp="fkcanbke6et3">
                  We use cookies and similar tracking technologies to track
                  activity on our website and hold certain information. Cookies
                  are files with a small amount of data which may include an
                  anonymous unique identifier. You can instruct your browser to
                  refuse all cookies or to indicate when a cookie is being sent.
                </p>
              </section>

              <section data-id="element-2609" data-mp="y995bgjpb9bu">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2610" data-mp="13a6h9be4b74w">
                  6. Third-Party Services
                </h2>
                <p data-id="element-2611" data-mp="303run7jcruxa">
                  In providing our services, we interact with third-party
                  platforms such as Google Ads, Meta (Facebook/Instagram), Yelp,
                  and various CRM providers. We may share necessary information
                  with these platforms solely for the purpose of executing the
                  marketing services you have contracted us to perform. We do
                  not sell your personal data to third parties.
                </p>
              </section>

              <section data-id="element-2612" data-mp="2iuz36auyk6ef">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2613" data-mp="2irjjeuqca96o">
                  7. Data Security
                </h2>
                <p data-id="element-2614" data-mp="3bibfztbbgzuj">
                  We implement appropriate technical and organizational security
                  measures designed to protect the security of any personal
                  information we process. However, please note that no
                  electronic transmission over the Internet or information
                  storage technology can be guaranteed to be 100% secure.
                </p>
              </section>

              <section data-id="element-2615" data-mp="1r0n7bwc3s8kg">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2616" data-mp="1r4b37250t72c">
                  8. Your Rights
                </h2>
                <p data-id="element-2617" data-mp="3v61gbcjwtuna">
                  Depending on your location, you may have certain rights
                  regarding your personal data, including the right to access,
                  correct, or delete the information we hold about you. To
                  exercise these rights, please contact us using the information
                  provided below.
                </p>
              </section>

              <section data-id="element-2618" data-mp="hqwuqlykr24h">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2619" data-mp="hq3jb7oo7og0">
                  9. Changes to This Privacy Policy
                </h2>
                <p data-id="element-2620" data-mp="3xno2t20gupn">
                  We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page and updating the "Last Updated" date.
                </p>
              </section>

              <section data-id="element-2621" data-mp="11ggrgy1e0jw5">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2622" data-mp="1atxxev6wx2g4">
                  10. Contact Us
                </h2>
                <p className="mb-2" data-id="element-2623" data-mp="16svxsd932odm">
                  If you have any questions about this Privacy Policy, please
                  contact us:
                </p>
                <ul className="list-none space-y-1" data-id="element-2624" data-mp="1kllj0fgsfp9o">
                  <li data-id="element-2625" data-mp="1flpg6jjtu3vp">
                    <strong data-id="element-2626" data-mp="1flfz5lgrf725">Company:</strong> Viridia Analytics
                  </li>
                  <li data-id="element-2627" data-mp="rvv3c1zicfbg">
                    <strong data-id="element-2628" data-mp="rx65jxdb1f0g">Location:</strong> Phoenix, AZ
                  </li>
                  <li data-id="element-2629" data-mp="nv2rr235xyc0">
                    <strong data-id="element-2630" data-mp="nvl0gy70i50t">Email:</strong>{' '}
                    <a href="mailto:info@viridiaanalytics.com" className="text-viridia hover:underline" data-id="element-2631" data-mp="11tj87kqtv37c">
                      info@viridiaanalytics.com
                    </a>
                  </li>
                  <li data-id="element-2632" data-mp="289btijiuwmvr">
                    <strong data-id="element-2633" data-mp="289v0j56yxqv0">Phone:</strong>{' '}
                    <a href="tel:6233000708" className="text-viridia hover:underline" data-id="element-2634" data-mp="2893gmrmqhhkk">
                      (623) 300-0708
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>;
}